import { render, staticRenderFns } from "./srPermissionGroups.vue?vue&type=template&id=608fdb09&scoped=true"
import script from "./srPermissionGroups.vue?vue&type=script&lang=js"
export * from "./srPermissionGroups.vue?vue&type=script&lang=js"
import style0 from "./srPermissionGroups.vue?vue&type=style&index=0&id=608fdb09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608fdb09",
  null
  
)

export default component.exports